import { SearchMatchType } from '@aibees/elephant/types';
import {
  companyDomainValueFormatter,
  linkedinUrlValueFormatter,
} from '../components/filter-tags/utils';
import {
  FieldValidationType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';

export default function companyInfoFilterConfig(): SearchFilterBase {
  return {
    id: 'Company Info',
    name: 'Company Info',
    icon: 'business-center',
    index: 0,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    items: [
      {
        index: 0,
        type: SearchFilterType.RADIO_GROUP,
        sections: { main: 3 },
        name: 'Company Info',
        icon: undefined,
        metadata: {
          singleEntry: true,
        },
        utils: {
          tags: {
            config: {
              showAsCard: true,
              tagsCardTitle: 'Company Info',
            },
          },
        },
        config: { labelKey: 'label', valueKey: 'value' },
        items: [
          {
            name: 'Company Name',
            type: SearchFilterType.TEXT_FIELD,
            icon: undefined,
            index: 0,
            exactMatch: {
              enabled: true,
              default: SearchMatchType.SMART,
            },
            key: 'include_company_name',
            field: 'include_company_name',
            metadata: {
              color: 'primary',
              placeholder: 'Enter Company Name',
              singleEntry: true,
            },
            open: true,
            layer: 4,
          },
          {
            name: ' Company Domain',
            type: SearchFilterType.TEXT_FIELD,
            icon: undefined,
            index: 0,
            key: 'include_company_domain',
            field: 'include_company_domain',
            metadata: {
              color: 'primary',
              placeholder: 'Enter Company Domain',
              singleEntry: true,
              validation: {
                type: FieldValidationType.COMPANY_DOMAIN,
                error: 'Kindly enter a valid Company Domain.',
              },
              delimiter: 'just to ensure valueFormatter is called',
            },
            utils: {
              valueFormatter: companyDomainValueFormatter,
            },
            open: true,
            layer: 4,
          },
          {
            name: 'LinkedIn Company URL',
            type: SearchFilterType.TEXT_FIELD,
            icon: undefined,
            index: 0,
            key: 'include_linkedin_url_for_account',
            field: 'include_linkedin_url_for_account',
            utils: {
              valueFormatter: linkedinUrlValueFormatter,
            },
            metadata: {
              color: 'primary',
              validation: {
                type: FieldValidationType.COMPANY_LINKEDIN_URL,
                error: 'Kindly enter a valid LinkedIn Company URL.',
              },
              placeholder: 'Enter LinkedIn Company URL',
              singleEntry: true,
              delimiter: '::',
            },
          },
          // TODO commented this because we will use it after
          // {
          //   name: 'Phone Number',
          //   type: SearchFilterType.TEXT_FIELD,
          //   icon: undefined,
          //   index: 0,
          //   layer: 4,
          //   key: 'include_phone_numbers_for_account',
          //   field: 'include_phone_numbers_for_account',
          //   metadata: {
          //     color: 'primary',
          //     validation: {
          //       type: FieldValidationType.PHONE,
          //       error: 'Kindly enter a valid phone number.',
          //     },
          //     placeholder: 'Enter phone number',
          //     singleEntry: true,
          //   },
          //   comingSoon: true,
          // },
        ],
      },
    ],
  };
}
